import load_maps from '../app/map';
import 'slick-carousel/slick/slick.min.js';
import AOS from 'aos/dist/aos.js';
import 'webticker/jquery.webticker.min.js';

export default {
    init() {
        // JavaScript to be fired on all pages
        load_maps();

        jQuery(function($) {
            $('a[href*="#"]:not([href="#"])').click(function() {
                if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                    if (target.length) {
                        $('html,body').animate({
                            scrollTop: target.offset().top - 50,
                        }, 1000);
                        return false;
                    }
                }
            });
        });

        if ( $( '.split-block--carousel .split-block__inner' ).length ) {
            $('.split-block--carousel .split-block__inner').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                autoplay: false,
                adaptiveHeight: false,
                appendDots: $('.split-block__dots'),
                fade: true,
                cssEase: 'linear',
            });

            var activeClass = 'slick-active',
                ariaAttribute = 'aria-hidden';
            $( '.split-block--carousel .split-block__inner' ).on( 'init', function() {
                $( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
            } ).on( 'afterChange', function( event, slick, currentSlide ) {
                var $dots = $( '.slick-dots' );
                $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
                $dots.each( function() {
                    $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
                } );
            } );
        }

        if ( $( '.vertical-slider' ).length ) {
            $('.vertical-slider').slick({
                dots: false,
                infinite: false,
                speed: 1000,
                autoplay: false,
                fade: true,
                prevArrow: '<button type="button" class="slick-prev"><</button>',
                nextArrow: '<button type="button" class="slick-next">></button>',
            });
        }

        if ( $( '.quote--carousel .quote__inner' ).length ) {
            $('.quote--carousel .quote__inner').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                autoplay: false,
                adaptiveHeight: false,
                fade: true,
                cssEase: 'linear',
            });
        }

        if ( $( '.latest-news__cards' ).length ) {
            $('.latest-news__cards').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: false,
                adaptiveHeight: false,
                fade: true,
                cssEase: 'linear',
            });
        }

        if ( $( '.usp-gallery__card' ).length ) {
            $('.usp-gallery__card').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                dots: true,
                fade: true,
                draggable: false,
            });

            $('.usp-gallery__card').on('click', function() {
                $(this).slick('slickNext');
            });
        }

        if ( $( '.js-testimonials-carousel' ).length ) {
            $('.js-testimonials-carousel').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                autoplay: false,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 1140,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 780,
                        settings: {
                            slidesToShow: 1,
                            dots: true,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 8000,
                        },
                    },
                ],
            });
        }

        $('.scroller__list').webTicker({
            duplicate: true,
            rssfrequency: 0,
            startEmpty: false,
            hoverpause: false,
            transition: 'ease',
        });

        $(window).load(function() {
            var container = '.post-list';
            var button = '.load-more a';
            $(document).on('click', button, function (e) {
                e.preventDefault();
                var $this = $(e.currentTarget);
                $this.addClass('disabled');
                $.get($this.attr('href'), function (data) {
                    var data_to_add = $(container + ' > div', data);
                    $(container).append(data_to_add);
                    $(document).trigger('pagination_load', [data_to_add]);
                    if ($(button, data).length <= 1) {
                        $this.remove();
                    } else {
                        $this.removeClass('disabled');
                        $this.attr('href', $(button, data).attr('href'));
                    }
                });
            });
        });

        AOS.init({
            once: true,
        });

        jQuery(document).on('click', '.js-toggle', function() {

            var $this = $(this);
            var $target;
            var target = $this.data('target');

            if (target) {
                $target = $(target);
            } else {
                $target = $this.closest('.js-toggleable');
            }

            $target.toggleClass('is-active');

        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js